<template>
    <div>
        <az-empty-state v-if="!dados" msg="Nenhuma operadora identificada." />

        <template v-else>
            <table class="table bg-white">
                <thead>
                    <tr>
                        <th width="1%">Atende</th>
                        <th width="40%">Operadora</th>
                        <th>Valor da Consulta</th>
                        <th>Código da Consulta 
                            <div class="small">AMB/CBHPM</div>
                        </th>
                        <th>Prazo de Revisão</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(oper, iox) in dados" :key="iox">
                        <td class="text-center">
                            <div class="mb-0" v-if="oper.operadoras.length">
                                <i class="fa fa-check-circle text-success fa-2x" aria-hidden="true"></i>
                            </div>
                            <az-input 
                                v-else
                                type="checkbox"
                                v-model="oper.selecionado" />
                        </td>
                        <td>
                            {{ oper.nome }}
                            <div class="small text-muted">
                                ANS: {{ oper.reg_ans }}
                                / CNPJ: {{ oper.cnpj }}
                            </div>
                        </td>
                        <td>
                            <template v-if="oper.selecionado">
                                <az-input 
                                    sizing="sm"
                                    type="money"
                                    required
                                    :validate="validate"
                                    v-model="oper.valor_consulta">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon2">R$</span>
                                        </div>
                                    </template>
                                </az-input>
                            </template>
                        </td>
                        <td>
                            <template v-if="oper.selecionado">
                                <az-input 
                                    sizing="sm"
                                    placeholder="10101012..."
                                    :validate="validate"
                                    v-model="oper.codigo_consulta">
                                </az-input>
                            </template>
                        </td>
                        <td>
                            <template v-if="oper.selecionado">
                                <az-input 
                                    sizing="sm"
                                    type="number"
                                    placeholder="30..."
                                    :validate="validate"
                                    v-model="oper.prazo_revisao">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">dias</span>
                                        </div>
                                    </template>
                                </az-input>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>

            <nav class="navbar fixed-bottom navbar-light bg-light pb-3 d-flex justify-content_between" v-if="selecionados.length">
                <div>
                    <az-submit @click="atualizar ()" class="mr-2">Incluir Selecionados</az-submit>
                </div>
            </nav>
            
            <pre v-if="false">{{ dados }}</pre>
        </template>
    </div>
</template>

<script>
import AzEmptyState from '../util/AzEmptyState.vue';
import AzInput from '../shared/forms/AzInput.vue';
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            dados: null, 
            validate: false, 
        };
    },

    components: { 
        AzEmptyState,
        AzInput,
        AzSubmit,
    },

    computed: { 
        selecionados: function () { 
            if ( !this.dados )
                return [];

            return this.dados.filter(item => item.selecionado);
        }
    },

    methods: { 
        load() { 
            this.validate = false; 

            this.$util.load(this, { 
                service: 'setup',
                func: 'operadoras',
            });
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'setup',
                func: 'salvar_operadoras',
                dados: { 
                    lista: this.selecionados
                }, 
                toast: true, 
                reload: true, 
            });
        }
    },

    mounted() { 
        this.load();
    }
}
</script>